import { Metadata } from "next";
import Register from "@/Component/Auth/Register"

export const metadata: Metadata = {
    title: "Register | Connector Club",
    description: "",
};

const RegisterPage = () => {
  return (
    <Register />
  )
}

export default RegisterPage
